import { ROLE_ESHOP } from '~/constants/roles.js'

export default function (context) {
    if (context.$auth.$state.user?.Role) {
        if (!context.$auth.$state.user.Role.includes(ROLE_ESHOP)) {
            context.redirect('/Dashboard')
        }
    }
}
